"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildVehiclesCatalogueQuery = void 0;
const vehiclesCatalogueQueryFields = `
  ...item
  ...product
  components {
    id
    content {
      ...basicComponents
      ...contentChunk
    }
  }
  model: parent {
    ...item
    components {
      id
      content {
        ...basicComponents
      }
    }
    modelSeries: parent {
      ...item
      components {
        id
        content {
          ...basicComponents
        }
      }
      manufacturer: parent {
        ...item
        components {
          id
          content {
            ...basicComponents
          }
        }
      }
    }
  }
`;
const vehiclesCatalogueQueryFragments = `
  fragment basicComponents on ComponentContent {
    ...singleLine
    ...richText
    ...numeric
    ...boolean
    ...propertiesTable
  }
  
  fragment item on Item {
    id
    name
  }
  
  fragment product on Product {
    defaultVariant {
      sku
      priceVariants {
        identifier
        price
      }
      images {
        ...image
      }
    }
  }
  
  fragment propertiesTable on PropertiesTableContent {
    sections {
      title
      properties {
        key
        value
      }
    }
  }
  
  fragment numeric on NumericContent {
    number
  }
  
  fragment boolean on BooleanContent {
    value
  }
  
  fragment singleLine on SingleLineContent {
    text
  }
  
  fragment richText on RichTextContent {
    plainText
  }
  
  fragment image on Image {
    url
    key
    variants {
      url
      width
      key
    }
  }
  
  fragment contentChunk on ContentChunkContent {
    chunks {
      id
      content {
        ...basicComponents
        ... on ItemRelationsContent {
          items {
            ...item
            ...product
            components {
              id
              content {
                ...basicComponents
                ... on ContentChunkContent {
                  chunks {
                    id
                    content {
                      ...basicComponents
                    }
                  }
                }
              }
            }
            manufacturer: parent {
              ...item
              components {
                id
                content {
                  ...basicComponents
                }
              }
            }
          }
        }
      }
    }
  }
`;
const hierarchyFragment = `
  catalogue(path: "/pim/vehicles", language: "no") {
    manufacturers: children {
      name
      series: children {
        name
        models: children {
          name
          salesPackages: children {
            name
            topics {
              path
            }
          }
        }
      }
    }
  }
`;
const buildVehiclesCatalogueQuery = (cataloguePaths) => `
   query VehicleCatalogue {
      ${cataloguePaths.map((path, index) => `
            salesPackage${index}: catalogue(path: "${path}", language: "no") {
              ${vehiclesCatalogueQueryFields}
            }
          `)}
      hierarchy: ${hierarchyFragment}
    }
    ${cataloguePaths.length > 0 ? vehiclesCatalogueQueryFragments : ''}
`;
exports.buildVehiclesCatalogueQuery = buildVehiclesCatalogueQuery;
//# sourceMappingURL=vehicle-catalogue.js.map